import { Col, Row, Tabs } from "antd";
import {
  ConstructionIcon,
  CrossIcon,
  CustomIcon,
  HolidayLightingIcon,
  IrrigationIcon,
  LandscapeIcon,
  LawnCareIcon,
  NeedHelp,
  PencilIcon,
  SnowServiceIcon,
  TickIcon,
  TreeServiceIcon,
} from "../../../atoms/CustomIcons";
import DashboardTemplate from "../../../templates/Dashboard";
import EnhancementsIcon from "../../../atoms/CustomIcons/EnhancementsIcon";
// import TabServices from "./Tabs/TabServices";
import CustomerManagement from "./Tabs/CustomerManagement";
import { useState } from "react";
import ProposalsAndContracts from "./Tabs/ProposalsAndContracts";
import CrewWorkSchedule from "./Tabs/CrewWorkSchedule";
import FieldWorkflow from "./Tabs/FieldWorkflow";
import Checklists from "./Tabs/Checklists";
import InvoicingAndBilling from "./Tabs/InvoicingAndBilling";
import IconCustomerManagement from "../../../atoms/CustomIcons/IconCustomerManagement";
import IconProposalContracts from "../../../atoms/CustomIcons/IconProposalContracts";
import IconServices from "../../../atoms/CustomIcons/IconServices";
import IconCrewWork from "../../../atoms/CustomIcons/IconCrewWork";
import IconFieldWorkflow from "../../../atoms/CustomIcons/IconFieldWorkflow";
import IconChecklist from "../../../atoms/CustomIcons/IconChecklist";
import IconInvoiceBilling from "../../../atoms/CustomIcons/IconInvoiceBilling";
import ServiceDetails from "../Services/ServiceDetails";
import Header from "../../../atoms/Header";
import { useAppSelector } from "../../../config/hooks";

type TabPosition = "left" | "right" | "top" | "bottom";

export default function Settings() {
  const [mode] = useState<TabPosition>("left");
  const [tabValue, setTabValue] = useState<string>("1");
  const [loading, setLoading] = useState<boolean>(false);
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const serviceLineDetail = useAppSelector(
    (state) => state?.services?.serviceLineDetail
  );

  const iconComponentMap: Record<string, React.ReactNode> = {
    ConstructionIcon: <ConstructionIcon />,
    CrossIcon: <CrossIcon />,
    CustomIcon: <CustomIcon />,
    EnhancementsIcon: <EnhancementsIcon />,
    HolidayLightingIcon: <HolidayLightingIcon />,
    IrrigationIcon: <IrrigationIcon />,
    LandscapeIcon: <LandscapeIcon />,
    LawnCareIcon: <LawnCareIcon />,
    PencilIcon: <PencilIcon />,
    SnowServiceIcon: <SnowServiceIcon />,
    TickIcon: <TickIcon />,
    TreeServiceIcon: <TreeServiceIcon />,
  };

  const tabsItems = [
    {
      key: "1",
      label: "Services",
      children: <ServiceDetails />,
      icon: <IconServices />,
    },
    {
      key: "2",
      label: "Customer management",
      children: <CustomerManagement setLoading={setLoading} />,
      icon: <IconCustomerManagement />,
      disabled: true,
    },
    {
      key: "3",
      label: "Proposals & contracts",
      children: (
        <ProposalsAndContracts setLoading={setLoading} loading={loading} />
      ),
      icon: <IconProposalContracts />,
      disabled: true,
    },
    {
      key: "4",
      label: "Crew work schedule",
      children: <CrewWorkSchedule setLoading={setLoading} />,
      icon: <IconCrewWork />,
    },
    {
      key: "5",
      label: "Field workflow",
      children: <FieldWorkflow setLoading={setLoading} />,
      icon: <IconFieldWorkflow />,
    },
    {
      key: "6",
      label: "Checklists",
      children: <Checklists />,
      icon: <IconChecklist />,
      disabled: true,
    },
    {
      key: "7",
      label: "Invoicing & billing",
      children: <InvoicingAndBilling />,
      icon: <IconInvoiceBilling />,
      disabled: true,
    },
    // {
    //   key: "8",
    //   label: "Job costing",
    //   children: <JobCosting setLoading={setLoading} />,
    //   icon: <IconJobCosting />,
    // },
  ];

  return (
    <DashboardTemplate loading={loading}>
      <Header
        breadcrumb={[
          { label: "Company settings", href: `/company-settings/${companyId}` },
          {
            label: "Service lines",
            href: `/company-settings/services/${companyId}`,
          },
          { label: serviceLineDetail?.data?.name ?? "" },
        ]}
        avatarIcon={
          (serviceLineDetail &&
            serviceLineDetail?.data &&
            iconComponentMap[serviceLineDetail?.data.icon]) ??
          ""
        }
        avatarColor={`${serviceLineDetail?.data?.color} defaultColor`}
        title={serviceLineDetail?.data?.name ?? ""}
        description={
          <span style={{ fontSize: 14 }}>
            Manage services and service line workflow settings
          </span>
        }
        btnText1="Need help?"
        btnIcon1={<NeedHelp />}
      />

      <div className="maxWidth service_line_settings">
        <Row gutter={16} wrap={false}>
          <Col span={24}>
            <div
              className={`main_column ${
                tabValue === "1" ? "serviceDetail" : ""
              } tab-${tabValue}`}
            >
              <Tabs
                defaultActiveKey="1"
                tabPosition={mode}
                style={{ height: "100%" }}
                items={tabsItems}
                activeKey={tabValue}
                onChange={(key) => setTabValue(key)}
              />

              {/* <div className="staff_and_labor">
                <Card>
                  <h4 style={{ marginBottom: "16px" }}>Staff & labor rates</h4>
                  <div style={{ marginBottom: "24px" }}>
                    <h6
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "12px",
                      }}
                    >
                      Production managers
                    </h6>
                    <Avatar.Group
                      size="small"
                      // max={{
                      //   count: 2,
                      //   style: {
                      //     color: "#f56a00",
                      //     backgroundColor: "#fde3cf",
                      //     cursor: "pointer",
                      //   },
                      //   popover: { trigger: "click" },
                      // }}
                    >
                      <Avatar src="/images/dummy/user.png" />
                      <Avatar src="/images/dummy/user.png" />
                      <Avatar src="/images/dummy/user.png" />
                    </Avatar.Group>
                  </div>

                  <div style={{ marginBottom: "24px" }}>
                    <h6
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "12px",
                      }}
                    >
                      Crews
                    </h6>
                    <div
                      style={{
                        display: "flex",
                        whiteSpace: "pre-wrap",
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      <Tag> LM1 - Chris H. </Tag>
                      <Tag> LC2 - Carlos R. </Tag>
                      <Tag> IR3 - Pedro P. </Tag>
                    </div>
                  </div>

                  <div style={{ marginBottom: "24px" }}>
                    <h6
                      style={{
                        fontSize: "12px",
                        fontWeight: "500",
                        marginBottom: "12px",
                      }}
                    >
                      Labor rate for estimates
                    </h6>

                    <h4> $70 / hr </h4>
                  </div>
                </Card>
              </div> */}
            </div>
          </Col>
        </Row>
      </div>
    </DashboardTemplate>
  );
}
